import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import classNames from 'classnames/bind'
import styles from './TruncatedText.module.scss'

const cx = classNames.bind(styles)

const TruncatedText = ({ children, as: Tag, className, placement, tooltipContent }) => {
  const ref = useRef(null)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleMouseEnter = () => {
    const el = ref.current
    if (el && el.scrollWidth > el.clientWidth) {
      setShowTooltip(true)
    }
  }

  const handleMouseLeave = () => setShowTooltip(false)

  return (
    <OverlayTrigger
      placement={placement}
      show={showTooltip}
      overlay={
        <Tooltip className={cx('tooltip')}>
          {tooltipContent != null ? tooltipContent : children}
        </Tooltip>
      }
    >
      <Tag
        ref={ref}
        className={className}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Tag>
    </OverlayTrigger>
  )
}

TruncatedText.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.elementType,
  className: PropTypes.string,
  placement: PropTypes.string,
  tooltipContent: PropTypes.node,
}

TruncatedText.defaultProps = {
  as: 'p',
  className: undefined,
  placement: 'top',
  tooltipContent: null,
}

export { TruncatedText }
